// extracted by css-extract-rspack-plugin
export default {"heading":"vT9DMLCUS2ggJmyY"};